import { useContext } from 'react';
import './ListHeader.css';
import { DialogContext } from '../../context/DialogContext'; // DialogContext import
import ListPageSetup from './ListPageSetup';

const ListHeader = ({
  keyword,
  setKeyword,
  handleSearch,
  sort,
  setSort,
  desc,
  setDesc,
  rowsPerPage,
  setRowsPerPage,
  total,
  sortOptions,
  page,
  setPage,
  totalPages,
  buttons = [] // 기본값으로 빈 배열 설정
}) => {
  const { openDialog, closeDialog } = useContext(DialogContext);

  // 설정 버튼 클릭 시 DialogContext를 통해 다이얼로그로 ListPageSetup을 띄움
  const handleSettingsClick = () => {
    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // 배경 색상
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
      },
    };

    openDialog(<ListPageSetup
      onClose={closeDialog}
      sort={sort}
      setSort={setSort}
      desc={desc}
      setDesc={setDesc}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}
      total={total}
      sortOptions={sortOptions}
    />, customStyles);
  };

  const handlePageChange = (newPage) => {
    console.log(`handlePageChange: ${newPage}`);
    if (newPage < 1 || newPage > totalPages) return;
    setPage(newPage);
  };

  return (
    <ul className="list_header">
      <li>
        <input
          type="text"
          placeholder="키워드 검색"
          className="keyword"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
        />
        <button onClick={handleSearch}>
          검색
        </button>
        <button onClick={handleSettingsClick}>
          설정
        </button>
        {/* buttons 배열을 제대로 렌더링 */}
        {buttons && buttons.length > 0 && buttons.map((button, index) => (
          <button
            key={index}
            onClick={button.onClick}
            style={button.style}
            disabled={button.disabled}
            className={button.className}
          >
            {button.text}
          </button>
        ))}
      </li>
      <li>
        <input type="number" className="page" value={page} onChange={(e) => setPage(Number(e.target.value))} />
        <span> / {totalPages} 페이지</span>
        <button onClick={() => handlePageChange(page - 1)} disabled={page === 1}>
          이전
        </button>
        <button onClick={() => handlePageChange(page + 1)} disabled={page === totalPages}>
          다음
        </button>
      </li>
    </ul>
  );
};

export default ListHeader;